import { HttpErrorResponse } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IResetUserRequest, password } from '@modeso/aumico-lib-users-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ofType } from '@ngrx/effects';
import { ActionsSubject, Store } from '@ngrx/store';
import Debug from 'debug';
import { filter, skip } from 'rxjs/operators';
import { LocalStorageService } from '../../../../../aumico-lib-core-fe/src/lib/services/localStorage.service';
import { Paths } from '../../enums/paths.enum';
import { AppState } from '../../state/app.state.reducer';
import { BasePageComponent } from '../base.page';
import { localizationKeys } from './../../utils/localizationKeys';

const debug = Debug('aumico:sass:ResetPasswordPage');
@UntilDestroy()
@Component({
    selector: 'app-page-reset-password',
    templateUrl: './reset.page.html',
    styleUrls: ['./reset.page.scss'],
})
export class ResetAccountPage extends BasePageComponent implements OnInit {
    localizationKeys = localizationKeys;
    resetForm: UntypedFormGroup;
    validSignup = false;
    invalidUser = false;
    isResetFailed = false;
    isServerError = false;
    isBadRequest = false;
    badRequestErrorMessage: string;
    constructor(
        injector: Injector,
        protected override router: Router,
        private readonly actionListener$: ActionsSubject,
        protected override localStorageService: LocalStorageService,
        protected store: Store<AppState>,
        protected route: ActivatedRoute,
    ) {
        super(injector);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.resetForm = new UntypedFormGroup({
            userName: new UntypedFormControl(null, { validators: [Validators.required, Validators.email] }),
        });

        this.authProvider
            .getUsersError$()
            .pipe(
                skip(1), // Skip the initial/last state
                filter((errorResponse: HttpErrorResponse) => errorResponse != null),
                untilDestroyed(this),
            )
            .subscribe((error) => {
                this.handleError(error);
            });
        this.actionListener$
            .pipe(ofType(password.sendEmailForResetSuccess), untilDestroyed(this))
            .subscribe(() => this.handleSuccess());
    }

    onResetAccount(): void {
        if (this.resetForm.invalid) {
            return;
        }
        const userData: IResetUserRequest = { email: this.resetForm.value.userName };
        this.authProvider.dispatchSendResetEmail(userData);
    }

    private handleSuccess(): void {
        this.navigateToInstructionPage();
    }

    private navigateToInstructionPage(): void {
        this.router.navigate(['../', Paths.RESET_INSTRUCTIONS], {
            relativeTo: this.route,
            queryParams: { email: this.resetForm.value.userName },
        });
    }

    private handleError(errorResponse: HttpErrorResponse): void {
        if (errorResponse.status?.toString() === '404') {
            this.isResetFailed = true;
            this.isServerError = false;
            this.isBadRequest = false;
        } else if (errorResponse.status?.toString() === '400') {
            this.isResetFailed = false;
            this.isBadRequest = true;
            this.isServerError = false;
            this.badRequestErrorMessage = errorResponse.error.error;
        } else {
            this.isServerError = true;
            this.isResetFailed = false;
            this.isBadRequest = false;
        }
    }

    buttonStatus(): boolean {
        return this.resetForm.invalid;
    }
}
